export var ProductId;
(function (ProductId) {
    /**
     * 经典版
     */
    ProductId[ProductId["Ymstock"] = 2] = "Ymstock";
    /**
     * 智盈
     */
    ProductId[ProductId["Skstock"] = 4] = "Skstock";
    /**
     * 有看投
     */
    ProductId[ProductId["Ycstock"] = 28] = "Ycstock";
})(ProductId || (ProductId = {}));
export var NativeProtocolMap = new Map([
    [ProductId.Ymstock, 'ymstock'],
    [ProductId.Skstock, 'skstock'],
    [ProductId.Ycstock, 'ycstock']
]);
/**
 * 客户端协议
 */
export var nativeProtocol = NativeProtocolMap.get(ProductId.Skstock);
/**
 * 设置客户端协议
 */
export function setNativeProtocol(protocol) {
    if (!protocol) {
        console.warn("[setNativeProtocol]: \u534F\u8BAE\u4E0D\u80FD\u4E3A\u7A7A\uFF08" + protocol + "\uFF09");
        return;
    }
    nativeProtocol = protocol;
}
/**
 * 通过pd获取客户端协议
 */
export function getNativeProtocolByProductId(productId) {
    var protocol = NativeProtocolMap.get(productId);
    if (!protocol) {
        console.warn("[getNativeProtocolByProductId]: \u672A\u77E5\u7684productId(" + productId + ")\uFF0C\u672A\u627E\u5230\u5BF9\u5E94\u7684\u5BA2\u6237\u7AEF\u534F\u8BAE");
    }
    return protocol;
}
/**
 * 通过pd设置客户端协议
 * @param productId 产品id
 */
export function setNativeProtocolByProductId(productId) {
    var protocol = NativeProtocolMap.get(productId);
    if (protocol) {
        setNativeProtocol(protocol);
    }
    else {
        console.warn("[setNativeProtocolByProductId]: \u672A\u77E5\u7684productId(" + productId + ")\uFF0C\u672A\u627E\u5230\u5BF9\u5E94\u7684\u5BA2\u6237\u7AEF\u534F\u8BAE");
    }
}
//# sourceMappingURL=protocol.js.map